/* istanbul ignore file */
import { CMSMenuLinksList } from './CMSMenuLinksList';

export default CMSMenuLinksList;
